<template>
    <base-dialog :loading="loading" :value="dialog" :width="480" :fullscreen="isMobile" :title="title"
        @input="val => { if (!val) hide() }" @close="hide">
        <template v-if="dialog">
            <basic-info-stepper v-if="mode === 'BasicInfo'" no-title @change="userData = $event" />
            <sport-record v-else-if="mode === 'SportRecord'" hide-title @change="userData = $event" />
            <place-training v-else-if="mode === 'PlaceTraining'" hide-title @change="userData = $event" />
            <choose-equipments v-else-if="mode === 'ChooseEquipments'" hide-title :selected="selectEquipments"
                @change="userData = $event" />
        </template>

        <template v-slot:footer>
            <div class="footer-row">
                <v-btn depressed x-large class="footer-cancel" @click="hide">
                    {{ $t('common.cancel') }}
                </v-btn>
                <v-btn depressed x-large color="primary" class="footer-save black--text" :disabled="disabled"
                    @click="save" :loading="loading">
                    {{ $t('common.save') }}
                </v-btn>
            </div>
        </template>
    </base-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { db } from "@/utils/Firebase";
import BaseDialog from "@/components/common/BaseDialog";
import BasicInfoStepper from "@/components/entrance/elements/BasicInfoStepper";
import SportRecord from "@/components/student/SportRecord";
import PlaceTraining from "@/components/student/PlaceTraining";
import ChooseEquipments from "@/components/student/ChooseEquipments";

export default {
    name: "EditProfileDialog",
    components: { BaseDialog, BasicInfoStepper, SportRecord, PlaceTraining, ChooseEquipments },
    data() {
        return {
            dialog: false,
            loading: false,
            mode: null,
            userData: null,
        }
    },
    computed: {
        title(vm = this) {
            return {
                BasicInfo: vm.$t('entrance.basic_info'),
                SportRecord: vm.$t('entrance.sport_record'),
                PlaceTraining: vm.$t('student.training_environments'),
                ChooseEquipments: vm.$t('student.work_elements'),
            }[vm.mode] || ''
        },
        disabled(vm = this) {
            if (vm.mode === 'BasicInfo') return !vm.userData || !vm.userData.name
            return false
        },
        selectEquipments(vm = this) {
            return vm.account?.equipments?.length > 0 ? vm.account.equipments : []
        }
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        show(mode) {
            const vm = this
            vm.mode = mode
            vm.userData = null
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.userData = null
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                const data = vm.userData || {}
                let payload = {}

                if (vm.mode === 'BasicInfo') {
                    payload = {
                        name: data.name,
                        phone: data.phone,
                        phoneCode: data.phoneCode,
                        birthDate: data.birthDate,
                        gender: data.gender,
                        country: data.country,
                    }
                } else if (vm.mode === 'SportRecord') {
                    payload = data
                } else if (vm.mode === 'PlaceTraining') {
                    payload = { places: Array.isArray(data) ? data : [] }
                } else if (vm.mode === 'ChooseEquipments') {
                    payload = { equipments: Array.isArray(data) ? data : [] }
                }

                await db.collection('users').doc(vm.currentUser.uid).update(payload)
                await vm.bindUserAccount(vm.currentUser)

                vm.hide()
                vm.toast(vm.$t('common.changes_saved'))
            })
        }
    }
}
</script>

<style scoped>
.footer-row {
    display: flex;
}

.footer-cancel {
    flex: 0 0 auto;
    border-radius: 0 !important;
    height: 52px !important;
    border-right: 1px solid var(--v-outline-base);
    background: var(--v-surface2-base) !important;
    color: var(--v-txtSecondary-base) !important;
    font-weight: 500;
}

.footer-save {
    flex: 1 1 auto;
    border-radius: 0 !important;
    height: 52px !important;
    font-weight: 700;
}
</style>
